"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSendAdapter = void 0;
const near_api_js_1 = require("near-api-js");
class MultiSendAdapter {
    sender;
    constructor(sender) {
        this.sender = sender;
    }
    static fromAccount(account) {
        return new MultiSendAdapter(account);
    }
    static fromWalletSelector(selector) {
        return new MultiSendAdapter(selector);
    }
    get networkId() {
        if ('accountId' in this.sender) {
            return this.sender.connection.networkId;
        }
        else {
            return this.sender.options.network.networkId;
        }
    }
    get nodeUrl() {
        if ('accountId' in this.sender) {
            return this.sender.connection.provider.connection
                .url;
        }
        else {
            return this.sender.options.network.nodeUrl;
        }
    }
    get accountId() {
        if ('accountId' in this.sender) {
            return this.sender.accountId;
        }
        else {
            const accountId = this.sender.getActiveAccount()?.accountId;
            if (!accountId) {
                throw new Error(`Active account id not found`);
            }
            return accountId;
        }
    }
    get near() {
        const networkId = this.networkId;
        const nodeUrl = this.nodeUrl;
        return new near_api_js_1.Near({
            networkId,
            nodeUrl,
        });
    }
    view(options) {
        return this.sender.view(options);
    }
    call(options) {
        return this.sender.call(options);
    }
    callRaw(options) {
        return this.sender.callRaw(options);
    }
    send(mTransaction, options) {
        return this.sender.send(mTransaction, options);
    }
    sendRaw(mTransaction, options) {
        return this.sender.sendRaw(mTransaction, options);
    }
}
exports.MultiSendAdapter = MultiSendAdapter;
//# sourceMappingURL=multi-send-adapter.js.map